import "react-phone-number-input/style.css";
import "./FormPhoneInput.css";
import PhoneInput from "react-phone-number-input";
import React from "react";

const FormPhoneFloatingInput = ({
  id,
  className,
  label,
  onChange,
  type = "text",
  placeholder,
}) => {
  return (
    <div className={className}>
      <label className="block tracking-wide font-semibold text-gray-400 text-md mb-2">
        {label}
      </label>
      <div className="relative flex flex-row shadow-sm hover:border-primary-400 hover:border-1 shadow-gray-500 rounded-md w-full">
        <PhoneInput
          defaultCountry="US"
          country="US"
          national
          countryCallingCodeEditable={false}
          className="p-2.5 px-4 font-bold h-[52px] shadow-gray-500 rounded-md w-full"
          type={type}
          placeholder={placeholder}
          onChange={(value) => onChange(value)}
        />
        <label
          for={`floating_filled ${id}`}
          class="absolute text-md text-gray-100 font-[60px]"
        >
          {placeholder}
        </label>
      </div>
    </div>
  );
};

export default FormPhoneFloatingInput;
